import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';


interface Props extends TypographyProps{
    text?: string;
    maxLength?: number;
};

export const CharacterCount: FC<Props> = (props) => {
  const { text, maxLength, ...typographyProps } = props;

  const currentLength = text?.length || 0;
  const remaining = maxLength ? maxLength - currentLength : 0;

  if (maxLength === undefined || maxLength <= 0) {
    return null;
  }

  return (
    <Typography variant="caption" color={remaining < 0 ? 'error.main' : 'textSecondary'} {...typographyProps}>
      {currentLength} / {maxLength}
    </Typography>
  );
};
